import { SxProps } from '@mui/material';
import { Fields } from 'common/form';
import { CampaignCreationSharedJobInformationFormData } from 'modules/campaign-creation-shared/forms/schema/campaignCreationSharedJobInformationSchema';

const jobInformationFieldSx: SxProps = {
  maxWidth: 500
};

export const campaignCreationSharedJobInformationFields: Fields<CampaignCreationSharedJobInformationFormData> =
  {
    jobTitle: {
      type: 'text',
      label: 'Job title',
      subLabel: 'Also used for [job_title] variable.',
      group: 'jobInformation',
      sx: jobInformationFieldSx
    },
    employerName: {
      type: 'text',
      label: 'Employer',
      subLabel: 'Also used for [client name] variable.',
      sx: jobInformationFieldSx
    },
    location: {
      type: 'text',
      label: 'Location',
      subLabel: 'Also used for [location] variable.',
      sx: jobInformationFieldSx
    },
    contractType: {
      type: 'text',
      label: 'Contract type',
      subLabel:
        'E.g. full time, contract, shift. Add hours, working days and so on.',
      sx: jobInformationFieldSx
    },
    additionalContext: {
      type: 'textarea',
      label: 'Additional information (optional)',
      rows: 8,
      group: 'additionalDetails',
      sx: {
        maxWidth: 650
      }
    }
  };
